<ng-container *ngIf="dcTypeMessage && dcTypeMessage != 'no-dc-type.listelement.badge'">
  <span class="badge badge-info">{{ dcTypeMessage | translate }}</span>
</ng-container>
